import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaGooglePlusG, FaPhoneAlt, FaEnvelope, FaArrowUp } from 'react-icons/fa';
import '../../assets/css/general/Footer.css';

const Footer = () => {
  const navigate = useNavigate();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleMakeReservations = () => {
    navigate('/customer/login');
  };

  return (
    <>
      {/* CTA Section - Let's Start Planning */}
      <section className="cta-section">
        <Container>
          <div className="cta-content">
            <h2 className="cta-heading">Book Your Wedding!</h2>
            <div className="cta-buttons">
              <button className="btn-cta-primary" onClick={handleMakeReservations}>
                📅 Make Reservations
              </button>
            </div>
          </div>
        </Container>
      </section>

      {/* Main Footer Section */}
      <footer className="footer-section">
        <Container>
          <Row className="footer-content-row">
            {/* Left Side - Company Info */}
            <Col lg={5} md={12} className="footer-about-col">
              {/* Decorative Hearts & Stars */}
              <div className="footer-decorations">
                <svg className="footer-star" width="25" height="25" viewBox="0 0 25 25" fill="none">
                  <path d="M12.5 2L14 8H20L15 12L17 18L12.5 14L8 18L10 12L5 8H11L12.5 2Z" fill="#a8e6cf" opacity="0.5"/>
                </svg>
                
                <svg className="footer-heart-1" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 21C12 21 3 15 3 9C3 6 5 4 7 4C9 4 10.5 5 12 6.5C13.5 5 15 4 17 4C19 4 21 6 21 9C21 15 12 21 12 21Z" fill="#ffb8b8" opacity="0.6"/>
                </svg>
                
                <svg className="footer-heart-2" width="22" height="22" viewBox="0 0 22 22" fill="none">
                  <path d="M11 20C11 20 3 14 3 8C3 5.5 5 4 7 4C8.5 4 10 5 11 6C12 5 13.5 4 15 4C17 4 19 5.5 19 8C19 14 11 20 11 20Z" fill="#7fd3c1" opacity="0.5"/>
                </svg>
              </div>

              {/* Logo Circle */}
              <div className="footer-logo-circle">
                <div className="logo-circle-bg">
                  <div className="footer-logo-icon">
                    <span className="footer-logo-letter">B</span>
                  </div>
                  <h4 className="footer-brand-name">Bridely</h4>
                  <p className="footer-brand-description">
                    Making every celebration effortless, elegant, and truly yours.
                  </p>
                  
                  {/* Social Media Icons */}
                  <div className="social-media-icons">
                    <a href="#" className="social-icon facebook-icon">
                      <FaFacebookF />
                    </a>
                    <a href="#" className="social-icon twitter-icon">
                      <FaTwitter />
                    </a>
                    <a href="#" className="social-icon linkedin-icon">
                      <FaLinkedinIn />
                    </a>
                    <a href="#" className="social-icon google-icon">
                      <FaGooglePlusG />
                    </a>
                  </div>
                </div>
              </div>
            </Col>

            {/* Right Side - Company Links & Contact */}
            <Col lg={7} md={12} className="footer-links-col">
              <Row>
                {/* Company Links */}
                <Col md={6} sm={12} className="footer-company-col">
                  <h5 className="footer-section-title">COMPANY</h5>
                  <Row>
                    <Col xs={6}>
                      <ul className="footer-links-list">
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/about">About</Link></li>
                        {/* <li><Link to="/services">Services</Link></li> */}
                        <li><Link to="/contact">Contact</Link></li>
                        <li><Link to="/blogs">Blog</Link></li>
                      </ul>
                    </Col>
                    <Col xs={6}>
                      <ul className="footer-links-list">
                        {/* <li><a href="#">Support</a></li>
                        <li><a href="#">Career</a></li> */}
                        {/* <li><a href="#">FAQ's</a></li> */}
                        {/* <li><a href="#">Blog</a></li> */}
                      </ul>
                    </Col>
                  </Row>
                </Col>

                {/* Contact Info */}
                <Col md={6} sm={12} className="footer-contact-col">
                  <div className="footer-contact-item">
                    <div className="contact-icon-wrapper">
                      <FaPhoneAlt className="contact-icon" />
                    </div>
                    <div className="contact-details">
                      <h6 className="contact-label">Call Us</h6>
                      <p className="contact-value">03441812760</p>
                    </div>
                  </div>

                  <div className="footer-contact-item">
                    <div className="contact-icon-wrapper">
                      <FaEnvelope className="contact-icon" />
                    </div>
                    <div className="contact-details">
                      <h6 className="contact-label">Email Us</h6>
                      <p className="contact-value">wed eve.com</p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          {/* Copyright Section */}
          <div className="footer-copyright">
            <p className="copyright-text">
              Copyright © Bridely 2024. All Rights Reserved.
            </p>
          </div>
        </Container>

        {/* Scroll to Top Button */}
        <button className="scroll-to-top-btn" onClick={scrollToTop}>
          <FaArrowUp />
        </button> 

        {/* Background Decoration */}
        <div className="footer-bg-decoration"></div>
      </footer>
    </>
  );
};

export default Footer;